import { render } from "./TaxNewinvoiceEn.vue?vue&type=template&id=8f7aa38e&scoped=true"
import script from "./TaxNewinvoiceEn.vue?vue&type=script&lang=js"
export * from "./TaxNewinvoiceEn.vue?vue&type=script&lang=js"

import "./TaxNewinvoiceEn.vue?vue&type=style&index=0&id=8f7aa38e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7aa38e"]])

export default __exports__